module.exports = __webpack_public_path__ + "media/newstyle/images/100-mil-book-db1a428232ede8e9953aa95448c54468.svg";